//Require scripts
import '../scss/app.scss';
import 'gsap';





// WEBPACK FOOTER //
// ./js/app.js